import { FeedPolicySearchType } from '@optools/services/operator-gateway/esni/types';
import { formatYearMonthDay } from '@optools/utils/datetime';
import { z } from 'zod';

export const querySchema = z
  .object({
    searchType: z.enum(FeedPolicySearchType).default(FeedPolicySearchType.DATE),
    searchValue: z.string().default(''),
  })
  .transform(({ searchType, searchValue }) => {
    const values = { searchType, searchValue };

    if (searchType === FeedPolicySearchType.DATE && !searchValue) {
      values.searchValue = formatYearMonthDay(new Date());
    }

    return values;
  });
